/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class e extends r{constructor(r,e){super(r,"sampler2DArray",0,(s,o)=>s.bindTexture(r,e(o)))}}export{e as Texture2DArrayBindUniform};
